import version from "./APP_VERSION";

const APP_VERSION = version.trim()

export default {
  APP_VERSION: APP_VERSION,
  APP_CLINIPASS_VERSION: "1.0.6",
}   